import React, { useState, useEffect } from "react"
import { Radio } from "antd"
import { Link } from "react-router-dom"
import { Card, Button, Modal } from "react-bootstrap"
import GeneralRatesHourly from "./GeneralRatesHourly"
import axios from "axios"
import GeneralTransportationsHourly from "./GeneralTransportationsHourly"
import GeneralHourly from "./GeneralHourly"

const GeneralServicesHourly = ({ product, hourlyId, hourlyProject }) => {
  const [hotelRates, setHotelRates] = useState([])
  const [hourlyHours, setHourlyHours] = useState([])
  const [tripPrice, setTripPrice] = useState(0)
  const [tripPriceBool, setTripPriceBool] = useState(false)
  const [numOfPassengers, setNumOfPassengers] = useState(0)
  const [kindOfTrip, setKindOfTrip] = useState("")
  const [chargeByPerson, setChargeByPerson] = useState(false)
  const [hotelName, sethotelName] = useState("")
  const [hours, setHours] = useState("")
  const [hotelId, sethotelId] = useState(0)
  const [hourId, setHourId] = useState(0)
  const [zoneId, setzoneId] = useState(0)
  const [hourZoneId, setHourZoneId] = useState(0)
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [numOfPass, setNumOfPass] = useState([])
  const [transportationId, setTransportationId] = useState([])
  const [transportationNameSelected, setTransportationNameSelected] =
    useState("")
  const [transportationIdSelected, setTransportationIdSelected] = useState(0)
  const [isSelectedHotel, setIsSelectedHotel] = useState(false)
  const [showTransportations, setshowTransportations] = useState(false)
  const [showHours, setShowHours] = useState(false)
  const [render, setRender] = useState(false)

  const server = "https://transportation-backend.link"

  const getPricesAPI = (
    transportationIdSelected,
    numofpass,
    hours,
    kindOfTrip,
    zoneId
  ) => {
    const fetchPrices = async () => {
      const { data } = await axios.get(
        `${server}/services/get-prices-hourly-zones/${zoneId}/${transportationIdSelected}/${hourlyId}`
      )
      if (data.length) {
        let departureprice = data[0].departureprice
        let arrivalprice = data[0].arrivalprice
        let roundprice = data[0].roundprice
        setTripPriceBool(true)

        //Condition for shuttle
        if (chargeByPerson) {
          if (kindOfTrip === "Departure") {
            setTripPrice(departureprice * numofpass)
          }
          if (kindOfTrip === "Arrival") {
            setTripPrice(arrivalprice * numofpass)
          }
          if (kindOfTrip === "Round") {
            setTripPrice(roundprice * numofpass)
          }
        }
        //Condition for private
        else {
          if (kindOfTrip === "Departure") {
            setTripPrice(departureprice * hours)
          }
          if (kindOfTrip === "Arrival") {
            setTripPrice(arrivalprice * hours)
          }
          if (kindOfTrip === "Round") {
            setTripPrice(roundprice * hours)
          }
        }
      } else {
        setTripPrice(0)
        setTripPriceBool(false)
      }
    }

    if (zoneId !== " " && transportationIdSelected !== " " && hours !== " ") {
      fetchPrices()
    } else {
      setTripPrice(0)
      setTripPriceBool(false)
    }
  }

  const fetchHotelRates = async (hourlyId) => {
    const { data } = await axios.get(`${server}/hotels-hourly/${hourlyId}`)

    data.unshift({
      id: 0,
      Name: " ",
    })

    setHotelRates(data)
  }

  const fetchHourlyHours = async (hourlyId) => {
    const { data } = await axios.get(`${server}/hourly-hours/${hourlyId}`)

    data.unshift({
      id: 0,
      Hours: " ",
    })

    setHourlyHours(data)
  }

  const fetchNumOfPass = async () => {
    const { data } = await axios.get(
      `${server}/services/num-of-pass-hourly/${product._id}/${hourlyId}`
    )

    let numPass = []
    let transpId = []

    for (let i in data) {
      numPass.push(data[i].NumOfPass)
      transpId.push(data[i].GeneralTransportationId)
    }
    transpId.unshift(" ")
    numPass.unshift(" ")
    setNumOfPass(numPass)
    setTransportationId(transpId)
  }

  useEffect(() => {
    fetchHotelRates(hourlyId)
    fetchHourlyHours(hourlyId)
    fetchNumOfPass()
  }, [])

  return (
    <div>
      <Card className='text-center'>
        <Card.Img src={product.image} variant='top' height='200px' />
        <Card.Body>
          <Card.Title as='h4'>
            <strong>{product.name}</strong>
          </Card.Title>
          <Card.Text as='h5'>{product.description}</Card.Text>
          <Card.Text as='h3'>${tripPrice}</Card.Text>
          <Radio.Group buttonStyle='solid'>
            <Card.Text as='h6'>
              <strong>Select Trip</strong>
            </Card.Text>

            {product.arrivaltrip && (
              <Radio.Button
                value='Arrival'
                onClick={(e) => {
                  setKindOfTrip("Arrival")
                  setChargeByPerson(product.chargebyperson)
                  isSelectedHotel === false
                    ? handleShow()
                    : getPricesAPI(
                        transportationIdSelected,
                        numOfPassengers,
                        hours,
                        "Arrival",
                        zoneId
                      )
                }}
              >
                Arrival
              </Radio.Button>
            )}

            {product.departuretrip && (
              <Radio.Button
                value='Departure'
                onClick={(e) => {
                  setKindOfTrip("Departure")
                  setChargeByPerson(product.chargebyperson)
                  isSelectedHotel === false
                    ? handleShow()
                    : getPricesAPI(
                        transportationIdSelected,
                        numOfPassengers,
                        hours,
                        "Departure",
                        zoneId
                      )
                }}
              >
                Departure
              </Radio.Button>
            )}

            {product.roundtrip && (
              <Radio.Button
                value='Round'
                onClick={(e) => {
                  setKindOfTrip("Round")
                  setChargeByPerson(product.chargebyperson)
                  isSelectedHotel === false
                    ? handleShow()
                    : getPricesAPI(
                        transportationIdSelected,
                        numOfPassengers,
                        hours,
                        "Round",
                        zoneId
                      )
                }}
              >
                Round
              </Radio.Button>
            )}
          </Radio.Group>

          {isSelectedHotel && (
            <GeneralRatesHourly
              hotelRates={hotelRates}
              value={hotelName}
              onChange={(event) => {
                sethotelId(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-hotelid"
                  )
                )
                setzoneId(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-zoneid"
                  )
                )
                sethotelName(event.target.value)
                getPricesAPI(
                  transportationIdSelected,
                  numOfPassengers,
                  hours,
                  kindOfTrip,
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-zoneid"
                  )
                )
                setRender({ ...render, value: true })
              }}
            />
          )}

          {isSelectedHotel && (
            <GeneralHourly
              hours={hourlyHours}
              value={hours}
              onChange={(event) => {
                setHours(event.target.value)
                getPricesAPI(
                  transportationIdSelected,
                  numOfPassengers,
                  event.target.value,
                  kindOfTrip,
                  zoneId
                )
                setshowTransportations(true)
              }}
            />
          )}

          {isSelectedHotel && (
            <GeneralTransportationsHourly
              product={product}
              transportationNameSelected={transportationNameSelected}
              transportationId={transportationId}
              numOfPass={numOfPass}
              onChange={(event) => {
                setTransportationNameSelected(event.target.value)
                setTransportationIdSelected(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-transpid"
                  )
                )
                setNumOfPassengers(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-numofpass"
                  )
                )
                getPricesAPI(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-transpid"
                  ),
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-numofpass"
                  ),
                  hours,
                  kindOfTrip,
                  zoneId
                )
              }}
            />
          )}
          <br />
          {tripPriceBool && (
            <Link
              to={{
                pathname: `/services-hourly/${product._id}/${hourlyId}`,
                state: {
                  tripPrice: tripPrice,
                  transportationNameSelected: transportationNameSelected,
                  kindOfTrip: kindOfTrip,
                  serviceId: product._id,
                  transportationIdSelected: transportationIdSelected,
                  hourlyId: hourlyId,
                  hourlyProject: hourlyProject,
                  hours: hours,
                },
              }}
            >
              <Button variant='outline-dark' size='md'>
                Buy
              </Button>
            </Link>
          )}
        </Card.Body>
      </Card>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>

        <Modal.Footer class='modal-title w-100 text-center'>
          <Card className='text-center'>
            <Card.Body>
              <GeneralRatesHourly
                hotelRates={hotelRates}
                value={hotelName}
                onChange={(event) => {
                  sethotelId(
                    event.target[event.target.selectedIndex].getAttribute(
                      "data-hotelid"
                    )
                  )
                  setzoneId(
                    event.target[event.target.selectedIndex].getAttribute(
                      "data-zoneid"
                    )
                  )
                  sethotelName(event.target.value)
                  setShowHours(true)
                }}
              />

              {showHours && (
                <GeneralHourly
                  hours={hourlyHours}
                  value={hours}
                  onChange={(event) => {
                    setHourId(
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-hourid"
                      )
                    )
                    setHourZoneId(
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-hour-zoneid"
                      )
                    )
                    setHours(event.target.value)
                    setshowTransportations(true)
                  }}
                />
              )}

              {showTransportations && (
                <GeneralTransportationsHourly
                  product={product}
                  transportationNameSelected={transportationNameSelected}
                  transportationId={transportationId}
                  numOfPass={numOfPass}
                  onChange={(event) => {
                    setTransportationNameSelected(event.target.value)
                    setTransportationIdSelected(
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-transpid"
                      )
                    )
                    setNumOfPassengers(
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-numofpass"
                      )
                    )
                    setIsSelectedHotel(true)
                    getPricesAPI(
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-transpid"
                      ),
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-numofpass"
                      ),
                      hours,
                      kindOfTrip,
                      zoneId
                    )
                    handleClose()
                  }}
                />
              )}
            </Card.Body>
          </Card>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default GeneralServicesHourly
